import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from '@/components/ui/dialog';

interface Props {
    invalidRows: number;
    showExportModal: boolean;
    closeBeforeExportSurveyModal: () => void;
    exportSurveyHandler: (exportInvalidRows: boolean) => void;
}

export default function BeforeExportDialog({
    invalidRows,
    showExportModal,
    closeBeforeExportSurveyModal,
    exportSurveyHandler
}: Props) {

    return (
        <Dialog open={showExportModal} onOpenChange={closeBeforeExportSurveyModal} defaultOpen={false}>
                <DialogContent className="max-w-fit">
                    <DialogHeader>
                        <DialogTitle className='text-start'>
                            <h2 className="mb-1">Some data is incorrect!</h2>
                        </DialogTitle>
                    </DialogHeader>

                    <div className="flex flex-col gap-2 p-1 mb-3">
                        <p className="text-sm">There {invalidRows === 1 ? "is" : "are"} <span className="font-medium">{invalidRows}</span> invalid row{invalidRows === 1 ? "" : "s"}</p>
                        <p className="text-sm">Do you want to export all values or only the correct ones?</p>
                    </div>

                    <DialogFooter>
                        <div className="flex items-stretch justify-end m-0 sm:space-x-2 max-sm:flex-col max-sm:space-y-2">
                            <Button variant='secondary' className="text-wrap h-auto text-sm" onClick={closeBeforeExportSurveyModal}>Close</Button>
                            <Button variant='destructive' className="text-wrap h-auto text-sm" onClick={() => exportSurveyHandler(true) }>Export All</Button>
                            <Button variant='default' className="text-wrap h-auto text-sm" onClick={() => exportSurveyHandler(false) }>Export Valid</Button>
                        </div>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
    );

}
